import {
  marketingConversationHydratedSchema,
  MarketingConversationTopic,
  queueCursorSchema,
  QueueType,
} from "@redotech/redo-model/marketing/marketing-conversation/marketing-conversation-definition";
import { marketingMessageSchema } from "@redotech/redo-model/marketing/marketing-message/marketing-message-definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getQueueConversations = {
  name: "getQueueConversations" as const,
  input: z.object({
    limit: z.number(),
    cursor: queueCursorSchema.optional(),
    queueType: createEnum(QueueType).default(QueueType.Default).optional(),
    currentQueueTopic: createEnum(MarketingConversationTopic).optional(),
  }),
  output: z.object({
    conversations: z.array(marketingConversationHydratedSchema),
    messagesMap: z.record(z.string(), z.array(marketingMessageSchema)),
    total: z.number(),
    nextCursor: queueCursorSchema.nullable(),
  }),
};
